import { pickKeys } from '@repo/platform-utils/object';
import { transformOfferImages } from '../image/transformOfferImages';
import { transformOfferDetailsFromMarketplaceEntity } from './transformMarketplaceEntity';
import type { BaseOffer } from './types';

export const TRANSFORMED_OFFER_ENTITY_KEYS = [
  'annualFee',
  'aprMin',
  'balanceTransferFee',
  'balanceTransferIntroApr',
  'balanceTransferIntroTime',
  'bestOfAwards',
  'cardUser',
  'cobrandAirline',
  'cobrandHotel',
  'cta',
  'displayName',
  'driverIntroApr',
  'driverRegularApr',
  'driverRewardRate',
  'entityType',
  'id',
  'image',
  'institution',
  'limitedCreditHistory',
  'minFico',
  'minimumDeposit',
  'name',
  'perks',
  'product',
  'productType',
  'purchaseIntroApr',
  'purchaseIntroTime',
  'rewards',
  'signUpBonus',
  'signUpBonusType',
  'starRating',
] as const satisfies readonly (keyof BaseOffer)[];

export function transformToCreditCardOffer(entity: BaseOffer) {
  const baseEntity = pickKeys(entity, TRANSFORMED_OFFER_ENTITY_KEYS);

  const offerDetails = transformOfferDetailsFromMarketplaceEntity(entity);

  return {
    ...baseEntity,
    details: offerDetails,
    imageOptions: transformOfferImages(entity.image),
  };
}
